export const enum ApplyStatusType {
  /** 0: 承認待ち */
  _0_WAIT,
  /** 1: 承認済み */
  _1_APPROVED,
  /** 2: 否認 */
  _2_REPUDIATION,
  /** 3: 即時承認 */
  _3_IMMEDIATE,
}
